const defaultPieChartColors = [
    '#04A4E1',
    '#2E7DC5',
    '#A3AEB3',
    '#6B79AE',
    '#20427D',
]

export const clientThemePaymentsave = {
    mainLayout: {
        backgroundColor: '#f4f4f5',
        hover: {
            backgroundColor: '#1C499A',
        },
    },
    topBar: {
        backgroundColor: '#232B44',
        contrastText: '#FFFFFF',
        contrastLinkText: '#C7C7C7',
        userIcon: '#FFFFFF',
        brandLogo: {
            maxWidth: '120px',
            paddingTop: '0px',
        },
        menuBarIcon: {
            color: '#FFFFFF',
        },
    },
    sidebar: {
        fontSize: '14px',
        backgroundColor: '#232B44',
        darkBackgroundColor: '#203A6F',
        sideMenuActive: {
            backgroundColor: '#2357B7',
            contrastText: '',
        },
        sideMenuHover: {
            backgroundColor: '#2E7DC5',
            contrastText: '',
        },
    },
    footer: {
        backgroundColor: '',
        contrastText: '',
    },
    charts: {
        fill: '#2E7DC5',
        stroke: '#2E7DC5',
        lineCharts: {
            stroke: '#2E7DC5',
            fill: '#2E7DC5',
        },
        areaCharts: {
            gradient: {
                start: '#2E7DC5',
                stop: '#2E7DC5',
            },
            stroke: '#2E7DC5',
            fill: '#2E7DC5',
            chargebacksByPostDateChart: {
                stroke: '#2E7DC5',
                fill: '#2E7DC5',
            },
            newAlertsByDateChart: [
                {
                    stroke: '#04A4E1',
                    fill: '#04A4E120',
                },
                {
                    stroke: '#2E7DC5',
                    fill: '#2E7DC520',
                },
                {
                    stroke: '#A3AEB3',
                    fill: '#A3AEB320',
                },
                {
                    stroke: '#6B79AE',
                    fill: '#6B79AE20',
                },
                {
                    stroke: '#20427D',
                    fill: '#20427D20',
                },
                {
                    stroke: '#95CFF2',
                    fill: '#95CFF220',
                },
                {
                    stroke: '#84ADDB',
                    fill: '#84ADDB20',
                },
                {
                    stroke: '#065CB4',
                    fill: '#065CB420',
                },
            ],
        },
        barCharts: {
            fill: '#04A4E1',
            byPlatformBarChart: { fill: '#04A4E1' },
            byBinBarChart: { fill: '#04A4E1' },
            ertsByRevenueChart: {
                bar1Fill: '#04A4E1',
                bar2Fill: '#2E7DC5',
            },
        },
        lineBarCharts: {
            byNonUniqueCustomerLineBarChart: {
                barColor: '#04A4E1',
                lineColor: '#6B79AE',
            },
        },
        pieCharts: {
            defaultPieChart: defaultPieChartColors,
            dashboardPieChart: defaultPieChartColors,
            byReasonCodePieChart: defaultPieChartColors,
            byReasonCodeDistributionPieChart: defaultPieChartColors,
            byCardTypePieChart: defaultPieChartColors,
            byLocationTypePieChart: defaultPieChartColors,
            byPlatformPerCardTypePieChart: defaultPieChartColors,
            byStatusPieChart: defaultPieChartColors,
            byWinLossPieChart: defaultPieChartColors,
        },
        radialBarCharts: {
            fill: '#2E7DC5',
        },
    },
    lockAndUnlockButton: {
        lockButton: {},
        unlockButton: {},
    },
    lampColors: {
        green: '#57a537',
        red: '#cb2022',
        orange: '#d87707',
        yellow: '#d8d800',
        grey: 'grey',
    },
    uploadDnD: {
        borderColor: `#cb2022`,
        backgroundColor: `rgba(203,32,34,.1)`,
        labelColor: `#cb2022`,
    },
    metricTile: {
        arrow: {
            width: 28,
            height: 28,
        },
    },
    caseBuilder: {
        color: '#1C499A',
        saveAndContinueBtn: {
            margin: '0px',
            fontWeight: 700,
            textTransform: 'capitalize',
            backgroundColor: '#1C499A',

            '&:hover': {
                backgroundColor: '#1C499A',
            },
        },
        submittingColor: '#3399CC',
    },
    accentAreaTopBorderAccent: {
        backgroundColor: '',
        borderRadius: '',
    },
    dateRangeContainer: {
        borderRadius: '',
        padding: '7px 8px',
    },
    selectionBox: {
        borderRadius: '4px',
    },
    formFields: {
        formLabel: {},
        formText: {
            standard: {
                color: '#27272a',
            },
            outlined: {
                fontSize: '',
            },
        },
    },
    labelTags: {
        borderRadius: '16px',
        backgroundColor: '#e4e4e7',
    },
    searchBar: {
        padding: '6px',
    },
    buttons: {
        styleButton: {
            root: {
                textTransform: 'capitalize',
            },
            contained: {
                textTransform: 'capitalize',
            },
        },
        defaultButton: {
            variant: 'contained',
            style: {
                backgroundColor: '#D3DBF8',
                color: '#122B58',
                borderRadius: '4px',
                '&:hover': {
                    backgroundColor: '#D3DBF8',
                },
            },
        },
        textOrOutlinedButton: {
            variant: 'outlined',
            style: {
                border: '1px solid #DDE2EB !important',
                borderRadius: '4px',
                color: '#263238',
                fontWeight: 600,
                padding: '4px 10px',
                fontSize: '14px',
                '&:hover': {
                    backgroundColor: 'rgba(38, 50, 56, 0.04)',
                },
            },
        },
        greyButton: {
            variant: 'contained',
            style: {
                color: '#71717a',
                borderRadius: '4px',
                backgroundColor: '#d4d4d8',
                '&:hover': {
                    color: '#71717a',
                    backgroundColor: '#d4d4d8',
                },
            },
        },
        greenButton: {
            variant: 'contained',
            style: {
                borderRadius: '4px',
                backgroundColor: '#31B98E',
                '&:hover': {
                    backgroundColor: '#23826F',
                },
            },
        },
        activeStateButton: {
            color: '#FFFFFF',
            backgroundColor: '#52525b',
        },
    },
    icons: {
        uploadIcon: '#3cb4e5',
        dnrAndRevertDnrIcon: '#3cb4e5',
        toggleUnlockIcon: '#75797b',
        toggleLockIcon: '#c80000',
        editUserIcon: '#2a7ea0',
        midPermissionIcon: '#714eb1',
        sitePermissionIcon: '#f88d2b',
        tempPasswordIcon: '#3cb4e5',
    },
    main: '#1C499A',
    primaryLight: '#1C499A',
    primary: '#1C499A',
    primaryDark: '#1C499A',
    secondaryLight: '#04A4E1',
    secondary: '#04A4E1',
    secondaryDark: '#04A4E1',
    hyperlink: '#1C499A',
    textField: '#1C499A',
    switch: '#1C499A',
    typography: {
        fontColor: {
            primaryText: '',
            secondaryText: '',
        },
        fontFamily: ['Roboto', 'sans-serif'],
        fontFamilyConfig: {
            primary: 'Roboto',
            fallback:
                '-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen-Sans, Ubuntu, Cantarell, Arial, sans-serif',
        },
        h1: {
            fontSize: '35px',
        },
        h2: {
            fontSize: '29px',
        },
        h3: {
            fontSize: '24px',
        },
        h4: {
            fontSize: '20px',
        },
        h5: {
            fontSize: '16px',
        },
        h6: {
            fontSize: '14px',
        },
        subtitle1: {
            fontSize: '16px',
        },
        subtitle2: {
            fontSize: '14px',
        },
        subtitle3: {
            fontSize: '15px',
        },
        subtitle4: {
            fontSize: '14px',
        },
        body1: {
            fontSize: '14px',
        },
        body2: {
            fontSize: '12px',
        },
        button1: {
            fontSize: '14px',
        },
        button2: {
            fontSize: '13px',
        },
        caption: {
            fontSize: '11px',
        },
        overline: {
            fontSize: '11px',
        },
        label: {
            fontSize: '14px',
        },
        dataGrid: {
            tableHeader: {
                fontSize: '12.8px',
            },
            tableBody: {
                fontSize: '14px',
                color: '#52525b',
            },
            tableExpandable: {
                fontSize: '14px',
            },
        },
    },
    shadows: {
        brandShadowLight: 'rgba(35, 43, 68, .4)',
    },
}
